export const Tabs = [

    {
        title: 'Description',
        route: '/contribution',
    },
    {
        title: 'Token Sale details',
        route: '/contribution/tokenSaleDetails'
    },
    {
        title: 'Recent transactions',
        route: '/contribution/recentTransactions'
    }
]


